<template>
  <div>
    <b-modal
      :id="modalId"
      :ref="modalId"
      :title="filmInfo"
      hide-footer
      @show="initSeatlayout"
      @hide="clearSeatLayout"
      centered
      no-close-on-esc
      no-close-on-backdrop
      no-fade
      no-stacking
      no-enforce-focus
      size="xl"
    >
      <div>
        <div class="loading" v-if="seatLoader">
          <div
            class="seatSection p-3 text-center d-flex align-items-center justify-content-center"
          >
            <b-spinner
              small
              variant="dark"
              label="Spinning"
              class="translate-spinner mr-2"
            ></b-spinner>
            <span class="fs-20">Fetching Seat Layout. Please Wait....</span>
          </div>
        </div>
        <div v-else :class="['pos-seatlayout seatname-is-active seatSection']">
          <table v-for="(seat, seatIndex) in seatType" :key="seatIndex">
            <tr>
              <td colspan="30">
                <div
                  class="relative mb-3"
                  v-bind:class="{ hideScreen: seatIndex != 0 }"
                >
                  <img
                    src="@/assets/img/pos/pos-screen.png"
                    class="img-fluid w-100"
                  />
                  <span
                    class="eyes-text"
                    :class="
                      reverse
                        ? 'pos-seatlayout-rotate-text font-weight-bold'
                        : 'font-weight-bold'
                    "
                    >{{
                      showDetails && showDetails.hasOwnProperty("screen_name")
                        ? "Screen - " + showDetails.screen_name
                        : ""
                    }}</span
                  >
                </div>
              </td>
            </tr>
            <!-- REGULAR SEATS -->

            <!-- SLIVER CLASS LABEL -->

            <tr v-if="!isWheelChairOnlyRow(seat.seatsFinal)">
              <td colspan="30">
                <div class="relative text-uppercase">
                  <span class="seatTypetext">
                    {{ seat.seatType }}
                    ({{ currFormat(seat.seat_price) }} {{ curr_code_mixin }})
                  </span>
                </div>
              </td>
            </tr>

            <tr
              v-for="(seatRow, seatRowIndex) in seat.seatsFinal"
              :key="seatRowIndex"
            >
              <div style="font-weight: bold">
                {{
                  getSafe(
                    () =>
                      seatRow.filter((r) => !!r.sl_seat_name)[0]
                        .sl_seat_name[0],
                    " "
                  )
                }}
              </div>
              <td
                v-for="(singleSeat, singleSeatIndex) in seatRow"
                :key="'index' + singleSeatIndex"
                :class="[
                  {
                    'lounger-container ': singleSeat.srt_seat_capacity > 1,
                  },
                  singleSeat['className'] ? singleSeat['className'] : '',
                ]"
              >
                <!-- {{singleSeat.seat_reserve_type_id}} -->
                <div
                  v-if="singleSeat.covidBlocked || singleSeat.covidBlockedTemp"
                  class="text-center"
                >
                  <!-- <CovidBlockedSeatIcon
                    :active="singleSeat.selectStatus == true"
                  /> -->
                </div>
                <div
                  v-else-if="singleSeat.seat_reserve_type_id == 5"
                  class="pos-seat cursor-pointer"
                  :style="{
                    borderColor:
                      singleSeat.selectStatus == true
                        ? '#01d04a !important'
                        : seat.seatsFinal[seatRowIndex][singleSeatIndex]
                            .sst_seat_color_code + ' !important',
                    backgroundColor:
                      singleSeat.selectStatus == true
                        ? ''
                        : seat.seatsFinal[seatRowIndex][singleSeatIndex]
                            .sst_seat_color_code + ' !important',
                  }"
                  :class="
                    singleSeat.isVipReserved
                      ? `${
                          false ? 'bg-qfx-unpaid mix-blend-mode' : ''
                        } reserved-seat taken pointer-events`
                      : singleSeat.srt_id == 2
                      ? 'normal-seat pointer-events'
                      : singleSeat.seat_reserve_type_id == 8
                      ? 'pointer-events'
                      : singleSeat.seat_reserve_type_id == 13
                      ? 'pointer-events'
                      : ''
                  "
                >
                  <img
                    :src="getSeatIconURL(singleSeat)"
                    height="28"
                    width="28"
                  />
                </div>
                <div
                  :style="{
                    pointerEvents: 'auto',
                    opacity: 1,
                    borderColor:
                      singleSeat.selectStatus == true
                        ? '#01d04a !important'
                        : singleSeat.seat_reserve_type_id == 8
                        ? checkSeatPriortyColor(singleSeat)
                        : singleSeat.seat_reserve_type_id == 4
                        ? 'green'
                        : seat.seatsFinal[seatRowIndex][singleSeatIndex]
                            .sst_seat_color_code + ' !important',
                    backgroundColor:
                      singleSeat.selectStatus == true
                        ? ''
                        : singleSeat.seat_reserve_type_id == 8
                        ? checkSeatPriortyColor(singleSeat)
                        : seat.seatsFinal[seatRowIndex][singleSeatIndex]
                            .sst_seat_color_code + ' !important',
                  }"
                  v-else
                  class="pos-seat cursor-pointer"
                  :class="
                    singleSeat.isVipReserved
                      ? `${
                          false ? 'bg-qfx-unpaid mix-blend-mode' : ''
                        } reserved-seat taken pointer-events`
                      : singleSeat.srt_id == 2
                      ? 'normal-seat pointer-events'
                      : singleSeat.seat_reserve_type_id == 8
                      ? 'pointer-events'
                      : singleSeat.seat_reserve_type_id == 13
                      ? 'pointer-events'
                      : ''
                  "
                >
                  <img
                    v-if="!checkSeatPriortyColor(singleSeat)"
                    :src="getSeatIconURL(singleSeat)"
                    height="28"
                    width="28"
                    :style="
                      singleSeat.seat_reserve_type_id == 4
                        ? 'background-color:green'
                        : ''
                    "
                  />
                </div>
                <div
                  v-if="singleSeat.srt_id == 2"
                  class="pos-seatNumber pt-1"
                ></div>
                <div v-else class="pos-seatNumber pt-1">
                  {{ singleSeat.sl_seat_name }}
                </div>
              </td>
            </tr>
          </table>

          <!--Seat Availability Section-->
          <div
            class="row mx-0 mt-5 justify-content-center mb-4"
            v-if="seatTypes"
          >
            <div
              class="d-flex justify-content-end align-items-center"
              style="text-align: center"
            >
              <div class="mx-1 height_cutsom">
                <div
                  class="pos-seat my-0 regular-seat seat-fixed-width mx-auto bg-blue"
                ></div>
                <span style="font-size: 12px"
                  >Regular {{ $tc("seat", 1) }}</span
                >
              </div>

              <div
                class="mx-1 height_cutsom"
                style="position: relative; top: 2px"
              >
                <div class="text-center mb-1">
                  <img
                    src="@/assets/img/pos/wheelchair.svg"
                    height="auto"
                    width="22"
                    alt
                  />
                </div>
                <span style="font-size: 12px">{{ $t("wheelchair") }}</span>
              </div>

              <div class="divider mx-1 height_cutsom"></div>

              <div class="mx-1 height_cutsom">
                <div class="pos-seat my-0 taken seat-fixed-width mx-auto"></div>
                <span style="font-size: 12px">{{ $t("taken") }}</span>
              </div>

              <div class="mx-1 height_cutsom">
                <div
                  class="pos-seat my-0 taken seat-fixed-width mx-auto unpaid"
                ></div>
                <span style="font-size: 12px">{{ $t("Unpaid") }}</span>
              </div>

              <div class="mx-1 height_cutsom">
                <div
                  class="pos-seat my-0 your-selection seat-fixed-width mx-auto"
                ></div>
                <span style="font-size: 12px"
                  >{{ $t("your") }} {{ $t("selection") }}</span
                >
              </div>

              <div class="mx-1 height_cutsom">
                <div
                  class="pos-seat my-0 house_seat seat-fixed-width mx-auto"
                ></div>
                <span style="font-size: 12px">{{ "House Seat" }}</span>
              </div>
            </div>
          </div>

          <div class="w-100 mt-5" v-if="seatType && seatType.length && false">
            <div
              v-for="(keyName, keyIndex) in Object.keys(defaultSeatSummary)"
              :key="keyIndex"
              class="w-100"
            >
              <div class="d-flex justify-content-center align-items-center">
                <div
                  class="channel-box"
                  v-for="(item, index) in defaultSeatSummary[keyName]"
                  :key="'channel-' + index"
                >
                  <div
                    class="colorNote"
                    :style="{
                      backgroundColor: item.channel_color,
                      color: getContrastColor(item.channel_color),
                    }"
                  >
                    <span class="font-bold text-sm">{{
                      item.booking_count
                    }}</span>
                  </div>
                  <span class="text-sm font-semibold">{{
                    item.channel_name
                  }}</span>
                  <!-- <div class="channelNote">{{ channel.channel_name }}</div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
        <footer v-if="true" class="footer summarySection">
            <div class="w-100 mt-5" v-if="seatType && seatType.length">
            <div
              v-for="(keyName, keyIndex) in Object.keys(defaultSeatSummary)"
              :key="keyIndex"
              class="w-100"
            >
              <div class="d-flex justify-content-center align-items-center">
                <div
                  class="channel-box"
                  v-for="(item, index) in defaultSeatSummary[keyName]"
                  :key="'channel-' + index"
                >
                  <div
                    class="colorNote"
                    :style="{
                      backgroundColor: item.channel_color,
                      color: getContrastColor(item.channel_color),
                    }"
                  >
                    <span class="font-bold text-sm">{{
                      item.booking_count
                    }}</span>
                  </div>
                  <span class="text-sm font-semibold">{{
                    item.channel_name
                  }}</span>
                  <!-- <div class="channelNote">{{ channel.channel_name }}</div> -->
                </div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </b-modal>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService.js";
import PosService from "@/services/PosService.js";
import _, { groupBy } from "lodash";

export default {
  props: {
    modalId: String,
    md_id: Number,
    screen_id: Number,
    ss_id: Number,
    cinema_id: Number,
    showDetails: {
      type: Object,
      default: () => {
        return {
          screen_name: "",
          movie_name: "",
          ss_actual_start_date: "",
          ss_start_show_time: "",
        };
      },
    },
    onHideModal: {
      type: Function,
      default: null,
    },
  },
  components: {},
  data() {
    return {
      defaultSeatSummary: {
        channelWiseBookings: [
          {
            channel_id: 4,
            channel_name: "Multiplex",
            channel_color: "#FF0000",
            booking_count: 0,
          },
          {
            channel_id: 9,
            channel_name: "Online",
            channel_color: "#ADD8E6",
            booking_count: "0",
          },
        ],
        paymentWiseSummary: [
          {
            channel_id: 1,
            channel_name: "Cash",
            channel_color: "#9ACD32",
            booking_count: 0,
          },
          {
            channel_id: 2,
            channel_name: "Card",
            channel_color: "#006400",
            booking_count: 0,
          },
          {
            channel_id: 47,
            channel_name: "Invitation",
            channel_color: "#a78977",
            booking_count: 0,
          },
        ],
        otherSummary: [
          {
            channel_id: 1,
            channel_name: "Available",
            channel_color: "#0000FF",
            booking_count: 0,
          },
          {
            channel_id: 2,
            channel_name: "Locked",
            channel_color: "#FFFF00",
            booking_count: 0,
          },
          {
            channel_id: 3,
            channel_name: "On Hold",
            channel_color: "#00008B",
            booking_count: 0,
          },
          {
            channel_id: 4,
            channel_name: "Unavailable",
            channel_color: "#808080",
            booking_count: 0,
          },
           {
            channel_id: 8,
            channel_name: "Broken",
            channel_color: "#ffffff",
            booking_count: 0,
          },
          {
            channel_id: 5,
            channel_name: "Disabled",
            channel_color: "#000000",
            booking_count: 0,
          },
          {
            channel_id: 6,
            channel_name: "Checked In",
            channel_color: "#F08080",
            booking_count: "0",
          },
          {
            channel_id: 7,
            channel_name: "Total",
            channel_color: "#006400",
            booking_count: "0",
          },
        ],
      },
      seatLoader: false,
      submitted: false,
      seatBookedSummmary: [],
      seatType: [],
    };
  },
  computed: {
    filmInfo() {
      console.log("this.showDetails", this.showDetails);
      let movieName = this.showDetails["movie_name"] || "";
      let showDate = this.showDetails["ss_actual_start_date"] || "";
      let showTIme = this.showDetails["ss_start_show_time"] || "";
      return `${movieName} | ${showDate} | ${showTIme}`;
    },
    showChannelWiseBookings() {
      return "Y";
    },
  },
  mounted() {},
  beforeMount() {},
  beforeDestroy() {},
  methods: {
    getContrastColor(bgColor) {
      let r, g, b;

      console.log("bgColor", bgColor);
      if (!bgColor) {
        return "black";
      }

      if (bgColor.startsWith("#")) {
        const hex = bgColor.replace("#", "");
        r = parseInt(hex.substring(0, 2), 16);
        g = parseInt(hex.substring(2, 4), 16);
        b = parseInt(hex.substring(4, 6), 16);
      } else if (bgColor.startsWith("rgb")) {
        const rgb = bgColor.match(/\d+/g);
        r = parseInt(rgb[0]);
        g = parseInt(rgb[1]);
        b = parseInt(rgb[2]);
      } else {
        console.error("Invalid background color:", bgColor);
        return "black"; // Default fallback
      }

      const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
      return luminance < 0.5 ? "white" : "black";
    },
    initSeatlayout() {
      setTimeout(() => {
        this.fetchSeatLayout();
      }, 400);
    },
    getSeatIconURL(singleSeat) {
      let iconPath = ``;
      if (singleSeat.selectStatus) {
        iconPath = this._GetImagePath(singleSeat.srt_dash_image_url_selected);
      } else if (
        singleSeat.seat_reserve_type_id == 12 ||
        singleSeat.seat_reserve_type_id == 8
      ) {
        iconPath = this._GetImagePath(singleSeat.srt_dash_image_url_disabled);
      } else {
        iconPath = this._GetImagePath(singleSeat.srt_dash_image_url);
      }
      // this.$forceUpdate();
      return iconPath;
    },
    checkSeatPriortyColor(seat) {
      if (
        this.showChannelWiseBookings == "Y" &&
        seat.hasOwnProperty("booking_color") &&
        seat["booking_color"]
      ) {
        return seat["booking_color"];
      } else {
        return "";
      }
    },
    toCheckAlphabets(str) {
      let regex = /[a-zA-Z]/g;
      let regexstrnNum = /^[A-Za-z0-9]*$/;

      if (str && str.match(regex)) {
        return true;
      }
      return false;
    },
    clearSeatLayout() {
      this.seatLoader = false;
      this.seatBookedSummmary = [];
      this.seatType = [];
      this.defaultSeatSummary = {
        channelWiseBookings: [
          {
            channel_id: 4,
            channel_name: "Multiplex",
            channel_color: "#FF0000",
            booking_count: 0,
          },
          {
            channel_id: 9,
            channel_name: "Online",
            channel_color: "#ADD8E6",
            booking_count: "0",
          },
        ],
        paymentWiseSummary: [
          {
            channel_id: 1,
            channel_name: "Cash",
            channel_color: "#9ACD32",
            booking_count: 0,
          },
          {
            channel_id: 2,
            channel_name: "Card",
            channel_color: "#006400",
            booking_count: 0,
          },
          {
            channel_id: 47,
            channel_name: "Invitation",
            channel_color: "#a78977",
            booking_count: 0,
          },
        ],
        otherSummary: [
          {
            channel_id: 1,
            channel_name: "Available",
            channel_color: "#0000FF",
            booking_count: 0,
          },
          {
            channel_id: 2,
            channel_name: "Locked",
            channel_color: "#FFFF00",
            booking_count: 0,
          },
          {
            channel_id: 3,
            channel_name: "On Hold",
            channel_color: "#00008B",
            booking_count: 0,
          },
          {
            channel_id: 4,
            channel_name: "Unavailable",
            channel_color: "#808080",
            booking_count: 0,
          },
          {
            channel_id: 5,
            channel_name: "Disabled",
            channel_color: "#000000",
            booking_count: 0,
          },
          {
            channel_id: 6,
            channel_name: "Checked In",
            channel_color: "#F08080",
            booking_count: "0",
          },
          {
            channel_id: 7,
            channel_name: "Total",
            channel_color: "#006400",
            booking_count: "0",
          },
        ],
      };
    },
    fetchSeatLayout() {
      if (
        this["md_id"] &&
        this["screen_id"] &&
        this["ss_id"] &&
        this["cinema_id"]
      ) {
        let payload = {
          md_id: this["md_id"],
          screen_id: this["screen_id"],
          ss_id: this["ss_id"],
          cinema_id: this["cinema_id"],
        };
        this.getSeatLayoutNew(payload);
      } else {
        this.$toasted.show(
          "Unable to fetch Seat Layout. Please refresh & Try Again."
        );
      }
    },
     createSummaryDetails(Records) {
      const actualSeats = Records.filter(
        (_seat) =>
          !["2", "12", "13"].includes(String(_seat.seat_reserve_type_id))
      );

      const reservedSeats = Records.filter(
        (_seat) =>
          ["8"].includes(String(_seat.seat_reserve_type_id))
      ).length || 0;

      const totalNotAvailable =
        Records.filter((_seat) =>
          ["12", "13"].includes(String(_seat.seat_reserve_type_id))
        ).length || 0;

      const totalSeatCount = actualSeats.length;

      const enteredCount =
        actualSeats.filter((_seat) => _seat.is_entered == "Y").length || 0;

      const totalBooked =
        actualSeats.filter((_seat) => _seat.booking_channel_id).length || 0;

      const totalReserved =
        actualSeats.filter((_seat) => _seat.isVipReserved).length || 0;

      let groupRecords = _.groupBy(actualSeats, "booking_channel_id");
      let groupRecordsPaymentWise = _.groupBy(
        actualSeats.filter((_items) => _items.booking_payment_id),
        "booking_payment_id"
      );
      if (Object.keys(groupRecords).length) {
        Object.keys(groupRecords).map((key) => {
          let tempObj = {
            channel_name: groupRecords[key].length
              ? groupRecords[key][0]["booking_channel"] || "Available"
              : "",
            channel_id: groupRecords[key].length
              ? groupRecords[key][0]["booking_channel_id"]
              : "",
            channel_color: groupRecords[key].length
              ? groupRecords[key][0]["booking_color"]
              : "",
            booking_count: parseInt(groupRecords[key].length || 0),
          };

          if (!tempObj["channel_id"]) {
            this.defaultSeatSummary["otherSummary"][0]["booking_count"] =
              tempObj["booking_count"];
          } else {
            let checkIndex = this.defaultSeatSummary[
              "channelWiseBookings"
            ].findIndex(
              (_channel) => _channel["channel_id"] == tempObj["channel_id"]
            );

            if (checkIndex > -1) {
              this.defaultSeatSummary["channelWiseBookings"][checkIndex][
                "channel_color"
              ] =
                tempObj["channel_color"] ||
                this.defaultSeatSummary["channelWiseBookings"][checkIndex][
                  "channel_color"
                ];

              this.defaultSeatSummary["channelWiseBookings"][checkIndex][
                "booking_count"
              ] =
                tempObj["booking_count"] ||
                this.defaultSeatSummary["channelWiseBookings"][checkIndex][
                  "booking_count"
                ];
            } else {
              this.defaultSeatSummary["channelWiseBookings"].push(tempObj);
            }
          }
          //   this.seatBookedSummmary.push(tempObj);
        });
      }

      if (Object.keys(groupRecordsPaymentWise).length) {
        Object.keys(groupRecordsPaymentWise).map((key) => {
          let tempObj = {
            channel_name: groupRecordsPaymentWise[key].length
              ? groupRecordsPaymentWise[key][0]["pm_payment_mode"] || "Others"
              : "",
            channel_id: groupRecordsPaymentWise[key].length
              ? groupRecordsPaymentWise[key][0]["booking_payment_id"]
              : "",
            channel_color: groupRecordsPaymentWise[key].length
              ? groupRecordsPaymentWise[key][0]["pm_color_code"]
              : "",
            booking_count: parseInt(groupRecordsPaymentWise[key].length || 0),
          };

          let checkIndex = this.defaultSeatSummary[
            "paymentWiseSummary"
          ].findIndex(
            (_channel) => _channel["channel_id"] == tempObj["channel_id"]
          );

          if (checkIndex > -1) {
            this.defaultSeatSummary["paymentWiseSummary"][checkIndex][
              "channel_color"
            ] =
              tempObj["channel_color"] ||
              this.defaultSeatSummary["paymentWiseSummary"][checkIndex][
                "channel_color"
              ];

            this.defaultSeatSummary["paymentWiseSummary"][checkIndex][
              "booking_count"
            ] =
              tempObj["booking_count"] ||
              this.defaultSeatSummary["paymentWiseSummary"][checkIndex][
                "booking_count"
              ];
          } else {
            this.defaultSeatSummary["paymentWiseSummary"].push(tempObj);
          }
          //   this.seatBookedSummmary.push(tempObj);
        });
      }

      let onProceesingSeats = parseInt(reservedSeats || 0) - parseInt(totalBooked || 0) - parseInt(totalReserved || 0)

      this.defaultSeatSummary["otherSummary"][6][
        "booking_count"
      ] = `${enteredCount}/${totalBooked}`;

      this.defaultSeatSummary["otherSummary"][7][
        "booking_count"
      ] = `${totalBooked}/${totalSeatCount}`;

      this.defaultSeatSummary["otherSummary"][2][
        "booking_count"
      ] = `${totalReserved}`;

      this.defaultSeatSummary["otherSummary"][4][
        "booking_count"
      ] = `${totalNotAvailable}`;

      this.defaultSeatSummary["otherSummary"][3][
        "booking_count"
      ] = `${parseInt(onProceesingSeats || 0)}`;

      this.defaultSeatSummary["otherSummary"][0]["booking_count"] =
              +parseFloat((totalSeatCount || 0) - (totalBooked || 0) - (totalReserved || 0) - (totalNotAvailable || 0))
    },
    async getSeatLayoutNew(payload) {
      console.log("showDetails", this.showDetails);
      this.seatLoader = true;
      let obj = {
        screen_id: payload.screen_id,
        ss_id: payload.ss_id,
        md_id: payload.md_id,
        cinema_id: payload.cinema_id,
        type_seat_show: 1,
        summary_info: true,
      };
      const response = await PosService.PosGetSeatLayout(obj);
      const { data } = response;

      this.seatLoader = false;

      if (data.Records.length > 0) {
        let create_seat_layout_dynamic_new = this.create_seat_layout_dynamic({
          seats: data,
          seatType: {
            Records: data.screen_seat_type,
            status: true,
          },
        });
        try {
          this.seatType = this.createSeatLayout(
            data.Records,
            data.screen_seat_type
          );
        } catch (e) {
          console.log("Error PosGetSeatLayout:", e);
          this.seatType = create_seat_layout_dynamic_new;
        }
        if (this.showChannelWiseBookings == "Y") {
          this.createSummaryDetails(data.Records);
        }
      }
    },
    createSeatLayout: function (flatSeats = [], screen_seat_type = []) {
      let seatsRowsRaw = [];

      seatsRowsRaw = _(flatSeats)
        .groupBy((item) => String(item.sl_row_num).padStart(4, "0"))
        .sortBy((group) => flatSeats.indexOf(group[0]))
        .value()
        .map((row) => {
          row.forEach((singleSeat) => {
            singleSeat.selectStatus = singleSeat.SelectStatusFlag = false;
          });
          return row.sort((a, b) => a.sl_col_num - b.sl_col_num);
        });

      let ssts = [];
      let sstsPayload = Array.from(screen_seat_type);
      let ssts_seats = [];
      let seatsRowsRawPrevIndex = 0;
      let seatsRowsRawlength = seatsRowsRaw.length;

      seatsRowsRaw.forEach((row, index) => {
        let sst = sstsPayload.filter((x) => x.sst_id == row[0].sst_id);
        if (ssts.length > 0 && ssts[ssts.length - 1].sst_id != row[0].sst_id) {
          ssts.push(sst[0]);
        }
        if (ssts.length == 0) {
          ssts.push(sst[0]);
        }

        const rowNext = seatsRowsRaw[index + 1];
        if (rowNext && row[0].sst_id != rowNext[0].sst_id) {
          ssts_seats.push(
            this.getSubarray(seatsRowsRaw, seatsRowsRawPrevIndex, index)
          );
          seatsRowsRawPrevIndex = index + 1;
        }
        if (rowNext == undefined) {
          ssts_seats.push(
            this.getSubarray(seatsRowsRaw, seatsRowsRawPrevIndex, index)
          );
          seatsRowsRawPrevIndex = seatsRowsRawlength;
        }
      });

      if (ssts.length !== ssts_seats.length) {
        throw new Error(
          "something went wrong with the seats array, ssts, ssts_seats doesnt match"
        );
      }

      return _.zipWith(ssts, ssts_seats, function (types, seats) {
        return {
          ...types,
          seatType: types.sst_seat_type,
          seat_net_price: seats.flatMap((x) => x)[0].seat_net_price || "",
          seat_price: seats.flatMap((x) => x)[0].seat_price || "",
          seats: seats.flatMap((x) => x),
          seatsFinal: seats.map((x) => x),
          debug: seats
            .flatMap((x) => x)
            .map((x) => x.sl_seat_name)
            .join(","),
        };
      });
    },
    create_seat_layout_dynamic(payload) {
      let seatData = [];
      let seatData1 = groupBy(payload.seats.Records, "sst_seat_type");
      payload.seatType.Records = payload.seatType.Records.sort(function (a, b) {
        return a.sst_order - b.sst_order;
      });

      payload.seatType.Records.map((type) => {
        for (var key in seatData1) {
          if (seatData1.hasOwnProperty(key)) {
            if (key == type.sst_seat_type) {
              seatData[key] = seatData1[key];
            }
          }
        }
      });
      let tempArray = [];
      for (let key in seatData) {
        if (seatData.hasOwnProperty(key)) {
          let seat_price = 0;
          let seat_net_price = 0;
          let seat_price_obj = seatData[key].filter((x) => {
            return x;
          });
          if (seat_price_obj) {
            seat_price = seat_price_obj[0].seat_price;
            seat_net_price = seat_price_obj[0].seat_net_price;
          }
          tempArray.push({
            seatType: key,
            seat_price: seat_price,
            seat_net_price: seat_net_price,
            seats: seatData[key],
          });
        }
      }
      for (let i = 0; i < tempArray.length; i++) {
        let singleSeatType = tempArray[i];

        let seatData_1 = groupBy(singleSeatType.seats, "sl_row_num");
        let tempArray_1 = [];
        for (let key in seatData_1) {
          let counter = 1;
          if (seatData_1.hasOwnProperty(key)) {
            let seatData_2 = seatData_1[key].map((singleSeat) => {
              singleSeat.selectStatus = false;
              singleSeat.SelectStatusFlag = false;
              singleSeat["className"] = null;
              if (
                singleSeat.hasOwnProperty("srt_seat_capacity") &&
                singleSeat.srt_seat_capacity > 1
              ) {
                singleSeat["className"] =
                  counter % 2 == 0
                    ? "even-lounger-container"
                    : "odd-lounger-container";
                counter++;
              }
              return singleSeat;
            });
            seatData_2 = seatData_2.sort(function (a, b) {
              return a.sl_col_num - b.sl_col_num;
            });

            tempArray_1.push(seatData_2);
          }
        }

        tempArray[i].seatsFinal = tempArray_1;
      }

      return tempArray;
    },
    getSubarray(array = [], fromIndex = 0, toIndex = 0) {
      let a = array;
      return a.slice(fromIndex, toIndex + 1);
    },
    isWheelChairOnlyRow(SeatTypeArray = []) {
      let statusCount = 0;

      SeatTypeArray.forEach((row) => {
        row.forEach((x) => {
          if (x.seat_reserve_type_id != 2 && x.seat_reserve_type_id != 3) {
            statusCount++;
          }
        });
      });

      if (statusCount > 0) {
        return false;
      } else {
        return true;
      }
    },
  },
};
</script>
<style scoped>
.listed-movie-time-list li.disabled {
  border-color: #d3d3d3;
  color: #fff;
  background: #d3d3d3;
  pointer-events: none;
  cursor: default;
}

.btn_min_width_190 {
  min-width: 190px;
}

.circle {
  border-radius: 50%;
  width: 1px;
  height: 15px;
  padding: 3px 4px;
  background: #fff;
  border: 1px solid #000;
  color: #000;
  text-align: center;
  font-size: 12px;
  font-weight: 500;
}

.al_dropdown button {
  font-size: 0.84rem;
  line-height: 1;
}

.avail {
  color: green;
}

#listed-movie-synopsis .btn-modal-close {
  top: -10px !important;
  right: -21px !important;
}

.no-padding {
  padding: 0px !important;
}

.search-input {
  /* top: 2.5px; */
  /* top: 0; */
  /* height: 55px; */
  /* font-size: 14px; */
  /* position: absolute; */
  /* width: 25%; */
  /*flex: 0 0 35%;*/
  min-width: 200px;
  /* left: 527px; */
}

.search-input .form-control {
  /* height: 45px; */
  height: 45px;
  /* border-radius: 20px; */
  border-radius: 50rem;
  font-size: 14px;
  width: 100%;
}

/* .pos-menus-hidden {
  top: -156px;
  height: 167px;
} */

/* .pos-modal-close {
  top: -11px !important;
    right: -30px !important;
} */

.viewSwap {
  cursor: pointer;
  text-decoration: underline;
}

/*@media (min-width: 992px) {*/

/* .seat_select_modal .modal-lg{*/
/*  max-width: 1030px;*/
/*  background-color: white;*/
/*  } */

/*}*/

.w-150 {
  min-width: 150px;
}

.seat-type {
  padding: 1rem;
  min-width: 200px;
  height: 115px;
  font-weight: bold;
}

#showRateCardPrice .seat-type {
  width: 280px !important;
}

.seat-type.gold {
  background-color: #fcf4d9;
  color: #f2c94c;
}

.seat-type.silver {
  background-color: #efefef;
  color: #a8a8a8;
}

.seat-type .st-name {
  font-weight: bold;
  font-size: 2.5rem;
  border-bottom: 1px solid #bfbfbf;
  line-height: 1;
  margin-bottom: 0.25rem;
  word-break: break-all;
}

#showRateCardPrice .category {
  width: 240px !important;
}

#showRateCardPrice .category .category-name {
  word-break: break-all;
}

.category {
  display: flex;
  flex-direction: column;
  width: 180px;
  height: 160px;
  background-color: #efefef;
  color: black;
  text-align: center;
  margin: 1rem;
  border-radius: 0.5rem;
}

.category.disabled {
  background-color: #f9f9f9;
  color: #999999;
}

.category.disabled .mod-btn {
  background-color: #afc8ed;
}

.category .category-name {
  font-size: 1.5rem;
  font-weight: 500;
  height: 53px;
  text-align: center;
  color: black;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.category .category-price {
  font-size: 1.5rem;
  font-weight: 500;
  height: 53px;
  text-align: center;
  color: black;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.category .category-seats {
  font-weight: bold;
  font-size: 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  border-top: 1px solid #bfbfbf;
  padding: 0.25rem;
  width: 100%;
  color: black;
  user-select: none;
}

.category .category-seats .mod-btn {
  font-weight: bold;
  font-size: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.5rem;
  color: white;
  background-color: #3876d2;
  height: 40px;
  width: 40px;
  border-radius: 0.25rem;
  cursor: pointer;
  transition: all 0.4s;
}

.category .category-seats .mod-btn:hover {
  color: #3876d2;
  background-color: white;
}

.category .category-seats .mod-btn:active,
.category .category-seats .mod-btn.active {
  transform: scale(0.8);
}

.category .category-seats .mod-btn.disabled,
.btn-submit-disabled {
  background-color: lightgrey;
  pointer-events: none;
}

.fl.btn-blue {
  font-size: 20px !important;
  padding: 1.5rem 2rem;
}

.currency-symbol {
  position: absolute;
  top: 50%;
  right: 10px;
  font-size: 12px;
  transform: translateY(-50%);
}

.InputAmount {
  padding-right: 3rem !important;
}

.noFnbItem {
  font-size: 13px;
}

.no-fnb-btn {
  background-color: white !important;
  color: red !important;
  border-color: red !important;
}

.status-dot {
  display: inline-block;
  margin-left: 6px;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background-color: var(--success);
}

.nfs-17 {
  font-size: 17px !important;
}

.voucher-box {
  height: 114px;
  margin: 22px;
  width: 40px;
  background: lightgray;
  border-radius: 10px;
}

.voucher_btn {
  background-color: var(--blue);
  color: white;
  border: 1px solid transparent;
  border-radius: 12px;
  /* padding: 16px; */
  padding: 8px;
  text-align: center;
  /* margin-bottom: 24px; */
  margin-bottom: 16px;
  line-height: 1.2;
  cursor: pointer;
  transition: border-color 0.5s, transform 0.5s, background-color 0.5s,
    color 0.5s;
  display: flex;
  flex-flow: column nowrap;
  /* height: 125px; */
  height: 80px;
  justify-content: center;
  align-items: center;
}

.voucher_btn:active {
  transform: scale(0.9);
}

.voucher_btn:active,
.voucher_btn.active,
.voucher_btn:hover {
  background-color: white;
  box-shadow: 0px 2px 6px -1px;
  color: var(--blue);
  border-color: var(--blue);
}

.giftcard_input {
  min-height: 175px;
}

.voucher_btn.inactive {
  /* background-color: grey;
  cursor: default;
  pointer-events: none;
  opacity: 0.2; */
  background-color: lightgray;
  cursor: default;
  pointer-events: none;
  opacity: 0.3;
  color: black;
}

.voucher_btn .voucher_btn__name > p {
  font-size: 18px;
  font-weight: bold;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  /* -webkit-line-clamp: 2; */
  -webkit-line-clamp: 1;
  margin-bottom: 0;
}

.voucher_btn .voucher_btn__screen > p {
  font-size: 18px;
  font-weight: bold;
  margin: 0;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.voucher_btn .voucher_btn__time > p {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 0;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.voucher_btn .voucher_btn__details {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.voucher_btn .voucher_btn__name + .voucher_btn__details {
  margin-top: 4px;
}

.voucher_btn .voucher_btn__details > div:nth-last-child(2) {
  max-width: 65%;
}

.voucher_btn .voucher_btn__details > div:nth-child(2) {
  margin-left: 12px;
}

.voucher_btn_row > article.col-6:nth-child(odd) {
  padding-right: 8px;
}

.voucher_btn_row > article.col-6:nth-child(even) {
  padding-right: 8px;
}

.pm_disbaled {
  opacity: 0.5;
  pointer-events: none;
}

.pos_booking_input_material .input-material input:focus + label,
.pos_booking_input_material
  .input-material
  input:not(:placeholder-shown)
  + label,
.pos_booking_input_material
  .input-material
  textarea:not(:placeholder-shown)
  + label,
.pos_booking_input_material
  .input-material-textarea
  textarea:not(:placeholder-shown)
  + label,
.pos_booking_input_material .input-material input.is_active + label {
  left: 36px;
  top: -5px;
  background-color: #fff;
  color: var(--blue);
  font-size: 12px;
}

.pos_booking_input_material .input-material input.is_active {
  color: #495057;
  background-color: #fff;
  /* border-color: #80bdff; */
  outline: 0;
  /* -webkit-box-shadow: 0 0 0 0.2rem rgb(0 123 255 / 25%); */
  /* box-shadow: 0 0 0 0.2rem rgb(0 123 255 / 25%); */
}

.pos_booking_input_material .input-material input + label,
.input-material textarea + label,
.input-material-textarea textarea + label {
  top: 18px;
  left: 36px;
}

.word-break {
  word-break: break-all;
}

@media screen and (min-width: 578px) and (max-width: 768px) {
  .img_height {
    height: 20vh;
  }
}

@media screen and (min-width: 769px) and (max-width: 991px) {
  .img_height {
    height: 20vh;
  }
}

@media screen and (min-width: 992px) and (max-width: 1200px) {
  .img_height {
    height: 21vh;
  }
}

@media screen and (min-width: 1201px) and (max-width: 1400px) {
  .img_height {
    height: 20vh;
  }
}

@media screen and (min-width: 1401px) and (max-width: 1600px) {
  .img_height {
    height: 20vh;
  }
}

@media (max-width: 1200px) {
  .pos-movie-listing-wrapper .btn-blue-lg {
    height: 40px !important;
    font-size: 12px;
  }

  .search-input .form-control {
    height: 40px;
  }
}

.normal-seat {
  display: none !important;
}

.seatNumList li {
  height: 35px;
  width: 35px;
  color: #ffffff;
  cursor: pointer;
  font-size: 14px;
  font-weight: 700;
  text-align: center;
  border-radius: 50%;
  align-items: center;
  display: inline-flex;
  justify-content: center;
  background-color: #979797;
  transition: transform 0.25s;
}

.seatNumList li.active,
.seatNumList li:hover {
  background-color: #3876d2;
}

/*@media (min-width: 992px) {*/

/* .seat_select_modal .modal-lg{*/
/*  max-width: 1030px;*/
/*  background-color: white;*/
/*  } */

/*}*/

.seatNumList li:active {
  transform: scale(0.85);
}

.seat-type {
  padding: 1rem;
  min-width: 200px;
  height: 115px;
  font-weight: bold;
}

.seat-type.gold {
  background-color: #f9f9f9;
  color: #f2c94c;
}

.seat-type.silver {
  background-color: #efefef;
  color: #a8a8a8;
}

.seat-type .st-name {
  font-weight: bold;
  font-size: 2.5rem;
  border-bottom: 1px solid #bfbfbf;
  margin-bottom: 0.25rem;
  word-break: break-all;
}

.category {
  display: flex;
  flex-direction: column;
  width: 180px;
  height: 160px;
  background-color: #efefef;
  color: black;
  text-align: center;
  margin: 1rem;
  border-radius: 0.5rem;
}

.category.disabled {
  background-color: #f9f9f9;
  color: #999999;
}

.category.disabled .mod-btn {
  background-color: #afc8ed;
}

.category .category-name {
  font-size: 1.5rem;
  font-weight: 500;
  height: 53px;
  text-align: center;
  color: black;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.category .category-price {
  font-size: 1.5rem;
  font-weight: 500;
  height: 53px;
  text-align: center;
  color: black;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.category .category-seats {
  font-weight: bold;
  font-size: 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  border-top: 1px solid #bfbfbf;
  padding: 0.25rem;
  width: 100%;
  color: black;
  user-select: none;
}

.category .category-seats .mod-btn {
  font-weight: bold;
  font-size: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.5rem;
  color: white;
  background-color: #3876d2;
  height: 40px;
  width: 40px;
  border-radius: 0.25rem;
  cursor: pointer;
  transition: all 0.4s;
  user-select: none;
}

.category .category-seats .mod-btn:hover {
  color: #3876d2;
  background-color: white;
}

.category .category-seats .mod-btn:active {
  transform: scale(0.8);
}

.fl.btn-blue {
  font-size: 20px !important;
  padding: 1.5rem 2rem;
}

#specify_seats_modal .seat-type {
  min-width: 292px !important;
}

#specify_seats_modal .category {
  width: 223px !important;
}

#specify_seats_modal .category .category-name {
  line-break: anywhere !important;
}

#specify_seats_modal .btn-modal-close {
  position: absolute;
  top: -7px !important;
  right: -8px !important;
}

.change_screen {
  transform: rotateX(180deg);
}

.pos-seatlayout-rotate {
  transform: scale(1, -1);
}

.pos-seatlayout-rotate-text {
  transform: scale(1, -1);
}

.large {
  transform: scale(1.2);
}

.height_cutsom {
  height: 75px;
}

.seatTypetext {
  width: 100%;
  font-weight: bold;
  font-size: 16px;
  padding: 8px 0px 8px 0px;
  text-align: center;
  letter-spacing: 1px;
  text-decoration: underline;
  /* border-bottom: 1px solid #000; */
  display: flex;
  justify-content: center;
  align-items: center;
}

.wheel_img {
  background-color: grey;
}

.seat_avail_sec span {
  font-size: 16px;
  font-weight: bold;
}

.avail_box {
  border: 0.5px solid #000;
  width: 30px;
  border-radius: 6px;
  background-color: transparent;
}

.block_seat {
  width: 30px;
  border-radius: 6px;
  background-color: transparent;
}

.bg-qfx-unpaid {
  background-color: #0384b4 !important;
}

.mix-blend-mode img {
  mix-blend-mode: hue;
}

.selected_show_time {
  border: none !important;
  background: var(--success) !important;
  color: white !important;
}

.custom_seat_selection_input {
  border: 1px solid grey;
  border-radius: 10px;
  padding: 5px 10px;
  width: 80px;
}

.custom_seat_selection_input:focus {
  border: 1px solid #75a7f0;
}

.custom_hr_seats {
  border-top: 1px solid #f0f0f0;
  margin: 1px auto;
}

.wheelChairWarning {
  font-size: 16px;
  font-weight: 500;
}

.channel-box {
  display: block !important;
  margin-right: 20px;
  text-align: center;
}

.colorNote {
  height: 35px;
  width: 120px;
  border-radius: 5px;
  border: 1px solid;
  text-align: center;
  align-items: center;
  display: flex;
  justify-content: center;
  font-size: 17px;
  font-weight: 500;
}

.channelNote {
  margin-inline: 5px;
  font-weight: bold;
  font-size: 18px;
}

.pos-seatlayout table td {
  min-width: 50px;
  max-width: 65px;
  min-height: 50px;
  padding-bottom: 2px;
  transition: 0.2s, transform 0.5s;
}

.seatSection {
  zoom: 0.7;
  max-height: 600px;
  overflow: auto;
  max-width: 100%;
  min-height: 600px;
}

.summarySection {
  zoom: 0.7;
}
</style>



// WEBPACK FOOTER //
// src/components/Partials/ShowSeatLayoutPopup.vue